interface ColorMapType {
  [key: string]: string;
}

export const ColorMap: ColorMapType = {
  //grayscale
  black: "#000000",
  white: "#FFFFFF",
  "gray-950": "#030712",
  "gray-900": "#111827",
  "gray-800": "#1f2937",
  "gray-700": "#374151",
  "gray-600": "#4b5563",
  "gray-500": "#6b7280",
  "gray-400": "#9ca3af",
  "gray-300": "#d1d5db",
  "gray-200": "#e5e7eb",
  "gray-100": "#f3f4f6",
  "gray-50": "#f9fafb",
  //purple
  "purple-900": "#3c0b5b",
  "purple-800": "#550e81",
  "purple-700": "#680ea0",
  "purple-600": "#7b0cc0",
  "purple-500": "#940ce8",
  "purple-400": "#a734f4",
  "purple-300": "#ba64f7",
  "purple-200": "#ce94f9",
  "purple-100": "#e7cffc",
  "purple-50": "#f2e7fe",
  //violet
  "violet-900": "#2b0b5b",
  "violet-800": "#380d77",
  "violet-700": "#440d96",
  "violet-600": "#500cb6",
  "violet-500": "#640ce8",
  "violet-400": "#7a34f4",
  "violet-300": "#9564f7",
  "violet-200": "#b394f9",
  "violet-100": "#d4c5fc",
  //green
  "green-900": "#15522d",
  "green-800": "#166534",
  "green-700": "#13823d",
  "green-600": "#18a14b",
  "green-500": "#21ca5f",
  "green-400": "#4bdd80",
  "green-300": "#8ce9ae",
  "green-200": "#bff3d1",
  "green-100": "#dff9e8",
  "green-50": "#f1fcf4",
  //blue
  "blue-900": "#1d3686",
  "blue-800": "#1f40ae",
  "blue-700": "#1d4ed8",
  "blue-600": "#2869eb",
  "blue-500": "#3484f4",
  "blue-400": "#60a5fa",
  "blue-300": "#93c3fd",
  "blue-200": "#bfdbfe",
  "blue-100": "#dbeafe",
  "blue-50": "#f0f6ff",
  //red
  "red-900": "#911212",
  "red-800": "#b61616",
  "red-700": "#ce1c1c",
  "red-600": "#e01f1f",
  "red-500": "#ef4444",
  "red-400": "#f37272",
  "red-300": "#f8abab",
  "red-200": "#fbcbcb",
  "red-100": "#fde3e3",
  "red-50": "#fef2f2",
  //orange
  "orange-900": "#8a3104",
  "orange-800": "#a83b04",
  "orange-700": "#c94605",
  "orange-600": "#e56306",
  "orange-500": "#fa7519",
  "orange-400": "#fb923c",
  "orange-300": "#fdb474",
  "orange-200": "#fed4aa",
  "orange-100": "#ffead5",
  "orange-50": "#fff6ed",
  //////////////////
  //////PAST//////
  //////////////////
  "gray-0": "#1d1d1f",
  "gray-1": "#2E2E33",
  "gray-2": "#45454A",
  "gray-3": "#5D5D62",
  "gray-4": "#74747B",
  "gray-5": "#8B8B91",
  "gray-6": "#A2A2A8",
  "gray-7": "#B9B9BE",
  "gray-8": "#D1D1D5",
  "gray-9": "#E8E8EC",
  "gray-10": "#F6F6F9",

  "codime-gradient": "linear-gradient(90deg, #a734f4 0%, #640ce8 100%);",

};
